import { render, staticRenderFns } from "./FotorConfirm.vue?vue&type=template&id=55b2934c&scoped=true"
import script from "./FotorConfirm.vue?vue&type=script&lang=js"
export * from "./FotorConfirm.vue?vue&type=script&lang=js"
import style0 from "./FotorConfirm.vue?vue&type=style&index=0&id=55b2934c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b2934c",
  null
  
)

export default component.exports